"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginConsentAttributes = void 0;
var LoginConsentAttributes;
(function (LoginConsentAttributes) {
    LoginConsentAttributes["NAME"] = "name";
    LoginConsentAttributes["ALIAS_NAME"] = "aliasname";
    LoginConsentAttributes["SEX"] = "sex";
    LoginConsentAttributes["RACE"] = "race";
    LoginConsentAttributes["SECONDARY_RACE"] = "secondaryrace";
    LoginConsentAttributes["DIALECT"] = "dialect";
    LoginConsentAttributes["NATIONALITY"] = "nationality";
    LoginConsentAttributes["DATE_OF_BIRTH"] = "dob";
    LoginConsentAttributes["BIRTH_COUNTRY"] = "birthcountry";
    LoginConsentAttributes["RESIDENTIAL_STATUS"] = "residentialstatus";
    LoginConsentAttributes["EMAIL"] = "email";
    LoginConsentAttributes["MOBILE_NUMBER"] = "mobileno";
    LoginConsentAttributes["REGISTERED_ADDRESS"] = "regadd";
    LoginConsentAttributes["MARITAL_STATUS"] = "marital";
    LoginConsentAttributes["MARRIAGE_DATE"] = "marriagedate";
    LoginConsentAttributes["OCCUPATION"] = "occupation";
    LoginConsentAttributes["EDUCATION_LEVEL"] = "edulevel";
    LoginConsentAttributes["COUNTRY_OF_MARRIAGE"] = "countryofmarriage";
    LoginConsentAttributes["MARRIAGE_CERT_NUMBER"] = "marriagecertno";
    LoginConsentAttributes["CHILDREN_BIRTH_CERT_NUMBER"] = "childrenbirthrecords.birthcertno";
    LoginConsentAttributes["CHILDREN_NAME"] = "childrenbirthrecords.name";
    LoginConsentAttributes["CHILDREN_DATE_OF_BIRTH"] = "childrenbirthrecords.dob";
    LoginConsentAttributes["CHILDREN_TOB"] = "childrenbirthrecords.tob";
    LoginConsentAttributes["CHILDREN_SEX"] = "childrenbirthrecords.sex";
    LoginConsentAttributes["CHILDREN_RACE"] = "childrenbirthrecords.race";
    LoginConsentAttributes["CHILDREN_SECONDARY_RACE"] = "childrenbirthrecords.secondaryrace";
    LoginConsentAttributes["CHILDREN_LIFE_STATUS"] = "childrenbirthrecords.lifestatus";
    LoginConsentAttributes["SPONSORED_CHILDREN_NRIC"] = "sponsoredchildrenrecords.nric";
    LoginConsentAttributes["SPONSORED_CHILDREN_NAME"] = "sponsoredchildrenrecords.name";
    LoginConsentAttributes["SPONSORED_CHILDREN_DOB"] = "sponsoredchildrenrecords.dob";
    LoginConsentAttributes["SPONSORED_CHILDREN_LIFE_STATUS"] = "sponsoredchildrenrecords.lifestatus";
    LoginConsentAttributes["SPONSORED_CHILDREN_NATIONALITY"] = "sponsoredchildrenrecords.nationality";
    LoginConsentAttributes["MERDEKA_GENERATION"] = "merdekagen";
    LoginConsentAttributes["PIONEER_GENERATION"] = "pioneergen";
    LoginConsentAttributes["GST_VOUCHER"] = "gstvoucher";
    LoginConsentAttributes["SILVER_SUPPORT"] = "silversupport";
})(LoginConsentAttributes || (exports.LoginConsentAttributes = LoginConsentAttributes = {}));
//# sourceMappingURL=login-consent-attributes.js.map